// extracted by mini-css-extract-plugin
module.exports = {"playerWrapper":"styled-module__playerWrapper___2qkDL"};